// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iframe-popover-parent {
  overflow-y: hidden;
}
.iframe-popover-parent::part(scroll) {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/external-link-content/external-link-content.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;AACJ","sourcesContent":[".iframe-popover-parent {\r\n  overflow-y: hidden;\r\n\r\n  &::part(scroll) {\r\n    overflow-y: hidden;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
